module.exports = __webpack_public_path__ + "static/media/HRECOS_Stations_West_Point.e2826f98.jpg";